import { Landmark, Building2, Route, Droplets, Trees, ShieldCheck, School, Users, TrainFront } from 'lucide-react';
import { IDS } from '@/constants/testIds';
import { useReveal } from '@/hooks/useReveal';

const DEPARTMENTS = [
  { icon: TrainFront, name: 'Indian Railways', short: 'Railway Dept.' },
  { icon: Route, name: 'Public Works Department', short: 'PWD' },
  { icon: Building2, name: 'Municipal Corporation', short: 'Nagar Nigam' },
  { icon: Trees, name: 'Rural Development', short: 'PMGSY' },
  { icon: Droplets, name: 'Public Health Engineering', short: 'PHED' },
  { icon: School, name: 'Education Department', short: 'Schools' },
  { icon: Landmark, name: 'Panchayati Raj', short: 'Gram Panchayat' },
  { icon: ShieldCheck, name: 'Home & Social Welfare', short: 'Govt of India' },
];

const DeptCard = ({ d, delay }) => {
  const r = useReveal(delay);
  const Icon = d.icon;
  return (
    <div
      ref={r.ref}
      className={`${r.className} bg-white p-8 flex flex-col items-start gap-4 group hover:bg-navy-900 transition-colors duration-500`}
    >
      <div className="w-14 h-14 border border-navy-200 group-hover:border-gold-400 flex items-center justify-center transition-colors">
        <Icon className="w-7 h-7 text-navy-700 group-hover:text-gold-300 transition-colors" />
      </div>
      <div>
        <div className="text-sm sm:text-base font-semibold text-navy-800 group-hover:text-white transition-colors">
          {d.name}
        </div>
        <div className="text-[10px] tracking-[0.24em] uppercase text-navy-400 group-hover:text-gold-300 mt-1 transition-colors">
          {d.short}
        </div>
      </div>
    </div>
  );
};

export const Departments = () => {
  const heading = useReveal(0);
  return (
    <section data-testid={IDS.departments.section} className="py-24 md:py-32 bg-cream">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div ref={heading.ref} className={`${heading.className} max-w-3xl mb-16`}>
          <div className="flex items-center gap-3 mb-6">
            <span className="gold-rule" />
            <span className="text-xs tracking-[0.28em] uppercase text-gold-500 font-bold">
              Trusted By
            </span>
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl text-navy-800 tracking-tight leading-[1.1]">
            Departments we are registered to serve.
          </h2>
          <p className="mt-5 text-base sm:text-lg text-navy-700/80 max-w-2xl">
            Empanelled and ready to bid for tenders across state, central and
            local government bodies.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-navy-100 border border-navy-100">
          {DEPARTMENTS.map((d, i) => (
            <DeptCard key={d.name} d={d} delay={i * 60} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Departments;
